module.exports = __webpack_public_path__ + "static/media/icon-logout-grey.898ce4e4.svg";